import getOr from "lodash/fp/getOr";
import { STATUS_ORDER, STATUS_ORDER_LIST } from "../utils/constant";
import { stringToPrice } from "../utils/currency";
import { Bank } from "./Bank";
import { Address } from "./Address";
import { Fee } from "./Fee";
import { OrderAction } from "./OrderAction";
import { Payment } from "./Payment";
import { Product } from "./Product";
// eslint-disable-next-line no-unused-vars
import { ProductGroupSite } from "./ProductGroupSite";

export class Order {
  constructor(code, billingAddress, shippingAddress, source, uid, payments, fees, details, groupSites, payAmount, payCurrency, bank, orderNo, userCode, note, isOwner, skuCount, totalQuantity, intermediateCheckoutUrl) {
    this.code = code;
    /** @type {Address}*/
    this.billingAddress = billingAddress;
    /** @type {Address}*/
    this.shippingAddress = shippingAddress;
    this.source = source;
    this.uid = uid;
    this.payments = payments;
    /** @type {[Fee]}*/
    this.fees = fees;
    /** @type {[Product]}*/
    this.details = details;
    /** @type {[ProductGroupSite]}*/
    this.groupSites = groupSites;
    this.payAmount = payAmount;
    this.payCurrency = payCurrency;
    this.bank = bank;
    this.orderNo = orderNo;
    this.userCode = userCode;
    this.note = note;
    this.isOwner = isOwner;
    this.skuCount = skuCount;
    this.totalQuantity = totalQuantity;
    this.intermediateCheckoutUrl = intermediateCheckoutUrl;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      let details = Product.fromApiArray(input.details);
      return new Order(
        input.code,
        Address.fromApiObject({
          ...input.billing_address,
          id: getOr(input.billing_address?.id, "id")(input.user_billing_address),
          address_type: getOr(input.billing_address?.address_type, "address_type")(input.user_billing_address)
        }),
        Address.fromApiObject({
          ...input.shipping_address,
          id: getOr(input.shipping_address?.id, "id")(input.user_shipping_address),
          address_type: getOr(input.shipping_address?.address_type, "address_type")(input.user_shipping_address)
        }),
        input.source,
        input.uid,
        Payment.fromApiArray(input.payments),
        Fee.mergeFee(Fee.fromApiArray(input.fees)),
        details,
        Product.groupProductWithSite(details),
        stringToPrice(input.pay_amount),
        input.pay_cur,
        Bank.fromApiObject(input.bank),
        input.order_no,
        input.user_code,
        input.note,
        input.is_owner,
        input.sku_count,
        input.total_quantity,
        input.intermediate_checkout_url,
      )
    }

    return new Order();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Order.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Order.fromApiObject(input)];
    }

    return [];
  }
  static genParamsOrder(params) {
    var result = {};
    if (params.code) {
      result[ORDER_PARAMS.CODE] = params.code;
    }
    if (params.note) {
      result[ORDER_PARAMS.NOTE] = params.note;
    }
    return result;
  }

  isRFQOrder() {
    let hasRFQProduct = this.details.find(element => element.type === Product.TYPE_PRODUCT.RFQ.id);
    if (hasRFQProduct) {
      let result = true;
      this.details.forEach(element => {
        if (element.canSelected()) {
          result = false;
        }
      });
      return result;
    } else {
      return false;
    }
  }

  getSelectedProducts() {
    let ids = [0];
    this.details.forEach(element => {
      if (Product.isSelected(element.type)) {
        ids.push(element.id);
      }
    });
    return ids;
  }

  /**
  * @returns { {total, stores} }
  */
  getTotalItem() {
    let total = 0, stores = [];
    this.details.forEach(function (element) {
      if (Product.isSelected(element.type)) {
        total += element.quantity * 1;

        if (!stores.includes(element.siteId)) {
          stores.push(element.siteId);
        }
      }
    });
    return {
      total: total,
      stores: stores
    }
  }

  /** @param {Order} order*/
  static getBadge(order, defaultValue = "") {
    let badge = 0;
    if (order.details.length) {
      order.details.forEach(product => {
        badge += product.quantity;
      });
    }
    const textBadge = badge > 99 ? "99+" : badge > 0 ? badge + "" : defaultValue;
    return {
      number: badge,
      text: textBadge
    }
  }

  getCancelItem() {
    let result = false;
    if (this.details && this.details.length) {
      for (let index = 0; index < this.details.length; index++) {
        const product = this.details[index];
        let cancel = product.audits?.find(item => item.action === STATUS_ORDER.CANCEL);
        if (cancel && cancel.createdAt) {
          result = cancel;
          break;
        }
      }
    }
    return result;
  }

  isCancelOrder() {
    let result = true;
    if (this.details && this.details.length) {
      for (let index = 0; index < this.details.length; index++) {
        const product = this.details[index];
        let item = product.audits.filter(item => item.action !== STATUS_ORDER.CANCEL);
        if (item.length > 0) {
          result = false; break;
        }
      }
    }
    return result;
  }

  isAllowCancelOrder() {
    let result = true;
    if (this.details && this.details.length) {
      for (let index = 0; index < this.details.length; index++) {
        const product = this.details[index];
        let currentStatus = STATUS_ORDER_LIST.find(i => i.id === OrderAction.getCurrentStatus(product.audits).action);
        let processPurchase = STATUS_ORDER_LIST.find(i => i.id === STATUS_ORDER.PROCESS_PURCHASE && i.id !== STATUS_ORDER.CANCEL);

        if (currentStatus.index >= processPurchase.index) {
          result = false;
          break;
        }
      }
    }
    return result;
  }
}

export const ORDER_PARAMS = {
  CODE: 'code',
  BILLING_ADDRESS: 'billing_address',
  SHIPPING_ADDRESS: 'shipping_address',
  SOURCE: 'source',
  UID: 'uid',
  PAYMENTS: 'payments',
  DETAILS: 'details',
  NOTE: 'note',
}
